<template>
  <div>
    <Header
      :headerTitle="$t('m.confirmOrder.title')"
      :hasBackBtn="true"
    ></Header>
    <!-- comfirmOdrerInfo -->
    <section class="main-container" style="margin-bottom:40px;padding-top:0">
      <div
        class="carTypeNo"
        v-show="!isCarIdRequired"
        style="border-bottom:1px solid #efefef;line-height:45px"
      >
        <p style="text-align:left;">
          <span @click="ProvinceList()">
            {{ provinceName }}&nbsp;
            <img src="../assets/img/xiala.png" />&nbsp;&nbsp;
          </span>
          <span>
            <input
              type="text"
              :placeholder="$t('m.confirmOrder.carPlaceholder')"
              style="display:inline-block;width:70%;border:0px;line-height: 35px;"
              v-model="lencesNumber"
              :readonly="selfService == 1"
              maxlength="7"
              :onkeyup="validLicense()"
            />
          </span>
        </p>
      </div>
      <div class="context" v-show="!isCarIdRequired">
        <p v-if="selfService != 1" style="text-align:left;">
          {{ $t("m.confirmOrder.tip") }}
        </p>
        <p v-if="selfService == 1" style="text-align:left;">
          *如需更换车牌，请前往用户中心解绑车辆后，重新认证
        </p>
      </div>

      <!-- <div class="contextInfo">
        <span class="dateType">{{$t('m.confirmOrder.chargeType')}}</span>
        <span class="dateTypes" @click="show">
            {{pickerSelect}}
          <img src="../assets/img/zhankai.png"/>
        </span>
          <awesome-picker
            ref="chargePicker"
            :data="picker.data"
            :anchor="picker.anchor"
            :textTitle="picker.textTitle"
            :textConfirm="picker.textConfirm"
            :textCancel="picker.textCancel"
            :swipeTime="picker.swipeTime"
            @cancel="handlePickerCancel"
            @confirm="handlePickerConfirm">
        </awesome-picker>
      </div> -->
      <div
        v-if="placeEmpty !== 'false' && radioTitle === true"
        style="  border-bottom: 1px solid #efefef;
    line-height: 13px;margin-top:13px;padding-bottom:8px;
    font-size: 13px;"
        class="charge-type"
      >
        <p class="charge-type-title">
          {{ $t("m.confirmOrder.chargeType") }}
          <label
            v-show="chargeType === 2"
            style="font-size:13px;margin-left:10vw;color:#EE3B3B"
          >
            {{ $t("m.confirmOrder.tipsModel4") }}</label
          >
        </p>
        <div
          style="display:flex;flex-direction:row;align-items:center;margin-top:13px;"
        >
          <input
            v-show="radio1Flag"
            type="radio"
            id="chargeType1"
            :value="3"
            v-model="chargeType"
          />
          <label v-show="radio1Flag" style="margin-left:1vw;margin-top:8px">
            {{ $t("m.confirmOrder.chargetInfo1") }}</label
          >
          <input
            v-show="radio2Flag"
            style="margin-left:10vw"
            type="radio"
            id="chargeType2"
            :value="2"
            v-model="chargeType"
          />
          <label v-show="radio2Flag" style="margin-left:1vw;margin-top:8px">
            {{ $t("m.confirmOrder.chargetInfo2") }}</label
          >
        </div>
      </div>

      <div
        v-show="placeEmpty === 'false'"
        style="  border-bottom: 1px solid #efefef;
    line-height: 35px;
    font-size: 13px;"
        class="charge-type"
      >
        <p class="charge-type-title">{{ $t("m.confirmOrder.chargeType") }}</p>
        <input
          ref="radio1"
          type="radio"
          id="chargeType3"
          :value="3"
          v-model="chargeType"
        />
        散停
      </div>

      <div class="contextInfo">
        <span class="dateType">{{ $t("m.confirmOrder.inTime") }}</span>
        <span class="dateTypes" @click="openPicker">
          {{ datePickerSelectAppointInTimeStr }}
          <img src="../assets/img/zhankai.png" />
        </span>
        <mt-datetime-picker
          :cancelText="$t('m.confirmOrder.cancel')"
          :confirmText="$t('m.confirmOrder.ok')"
          ref="picker"
          v-model="datePickerSelectAppointInTime"
          type="datetime"
          :year-format="$t('m.confirmOrder.year')"
          :month-format="$t('m.confirmOrder.month')"
          :date-format="$t('m.confirmOrder.day')"
          minute-format="{value}"
          :startDate="appointInTimeStart"
          :endDate="appointInTimeEnd"
          @confirm="handleConfirm"
        ></mt-datetime-picker>
      </div>
      <div class="contextInfo">
        <span class="dateType">{{ $t("m.confirmOrder.outTime") }}</span>
        <span class="dateTypes" @click="openPicker(2)">
          {{ datePickerSelectAppointOutTimeStr }}
          <img src="../assets/img/zhankai.png" />
        </span>
        <mt-datetime-picker
          :cancelText="$t('m.confirmOrder.cancel')"
          :confirmText="$t('m.confirmOrder.ok')"
          class="mt-datetime-two"
          ref="picker2"
          v-model="datePickerSelectAppointOutTime"
          type="datetime"
          :year-format="$t('m.confirmOrder.year')"
          :month-format="$t('m.confirmOrder.month')"
          :date-format="$t('m.confirmOrder.day')"
          :startDate="appointOutTimeStart"
          :endDate="appointOutTimeEnd"
          @confirm="handleConfirm(2)"
        ></mt-datetime-picker>
      </div>

      <!-- <div class="contextInfo">
        <span class="dateType">{{$t('m.confirmOrder.card')}} </span>
         <b-form-select  aria-selected="" v-if="cardType.length>0" style="padding-left:30px;width:38%;border:none;height:30px;margin-left:150px" v-model="selectedCard">
             <option
                 v-for="(items,index) in cardType"
                 :key="index"
                 :value="items.vipTypeId"
             ><span>{{items.discount*10 }} 折卡</span>
             </option>
           </b-form-select>
           <span style="width:40%;border:none;height:30px;margin-left:200px" v-if="cardType.length==0">无会员卡</span>
      </div> -->
      <!-- 常用小时 -->
      <div id="date">
        <p>
          {{ $t("m.confirmOrder.choicesTine") }}
          <span style="float:right" @click="carDate()">
            {{ $t("m.confirmOrder.more") }}
            <img src="../assets/img/zhankai.png" />
          </span>
        </p>
        <b-container fluid class="bv-example-row">
          <b-row>
            <b-col
              v-for="(item, index) in allPricingList"
              :key="index"
              v-if="index < 4"
              @click="getDataOrder(item.hour)"
              :class="{ active: appointHour == item.hour }"
            >
              <div class="em-line">
                <em v-if="$i18n.locale == 'zh_CN'">
                  {{ isVip ? "VIP " : ""
                  }}{{
                    (item.discount * 10).toFixed(1) + $t("m.confirmOrder.off")
                  }}
                </em>
                <em v-if="$i18n.locale == 'en_US'">
                  {{ isVip ? "VIP " : "" }}-
                  {{
                    (100 - item.discount * 100).toFixed(0) +
                      $t("m.confirmOrder.off")
                  }}
                </em>
              </div>
              <strong>{{ item.hour }}</strong>
              {{
                item.hour <= 1
                  ? $t("m.parkingDuration.hour")
                  : $t("m.parkingDuration.hours")
              }}
              <p>
                <span>{{ item.price }}{{ $t("m.confirmOrder.CNY") }}</span>
                {{ item.discountPrice }} {{ $t("m.confirmOrder.CNY") }}
              </p>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <!-- 选中获取的信息 -->
      <div class="cost">
        <div class="carDate">
          <p>{{ $t("m.confirmOrder.hours") }}</p>
          <h5>
            <span>{{ appointHour }}</span>
            {{ $t("m.confirmOrder.hours") }}
          </h5>
        </div>
        <div class="carDates">
          <p>{{ $t("m.confirmOrder.money") }}</p>
          <h5>
            <span>{{ money }}</span>
            {{ $t("m.confirmOrder.CNY") }}
          </h5>
        </div>
        <p style="text-align:right;padding:0 10%;font-size:14px;color:#0066B1;">
          <s style="color:#777474;;"
            >{{ selectPrice }}{{ $t("m.confirmOrder.yuan") }}&nbsp;</s
          >
          <span v-if="$i18n.locale == 'zh_CN'">{{
            (selectDiscount * 10).toFixed(1) + $t("m.confirmOrder.off")
          }}</span>
          <span v-if="$i18n.locale == 'en_US'"
            >&nbsp;&nbsp;-{{
              (100 - selectDiscount * 100).toFixed(0) + $t("m.confirmOrder.off")
            }}</span
          >
        </p>
      </div>
      <!-- 用户协议 -->
      <div class="userProtocol">
        <b-form-checkbox
          :checked="defaultChecked"
          @change="onDefaultChecked"
        ></b-form-checkbox>
        <div class="tongyi">
          {{ $t("m.confirmOrder.accept") }}
          <router-link to="/userTreaty">
            <span style="color:#0066B1">{{
              $t("m.confirmOrder.selectAgreement")
            }}</span>
          </router-link>
          <router-link to="/policy">
            <span style="color:#0066B1">{{
              $t("m.confirmOrder.selectpolicy")
            }}</span>
          </router-link>
        </div>
      </div>
    </section>
    <!-- footer button -->
    <footer>
      <p>{{ $t("m.confirmOrder.bottomTop") }}</p>
      <b-button
        href="#"
        :disabled="
          disabledBtn && (appointHour === 0 || !defaultChecked || !lencesNumber)
        "
      >
        <!--   v-show="!isCarIdRequired" -->
        <span style="display:block;" @click="sumitOrder()">{{
          $t("m.confirmOrder.button")
        }}</span>
      </b-button>

      <b-modal
        ref="beijingparkingInfo"
        class="cancelOrders"
        style="margin-top:30px"
        ok-only
        :ok-title="$t('m.home.ok')"
      >
        <p
          class="my-4"
          style="margin-bottom:15px !important;padding:5px 25px;font-size:15px;"
        >
          {{ $t("m.home.tips") }}
        </p>
        <!-- <span >{{$t('m.home.tips')}}</span> -->
      </b-modal>
      <b-modal
        ref="disperserSelect"
        class="cancelOrders"
        :cancel-title="$t('m.confirmOrder.modelCancel')"
        :ok-title="$t('m.confirmOrder.modelOk')"
        @cancel="disabledBtn = true"
        @ok="disperserOrder()"
      >
        <p
          class="my-4"
          style="margin-bottom:5px !important;padding:0 25px;font-size:15px;"
        >
          {{ $t("m.confirmOrder.tipsModel1") }}
        </p>
        <p
          class="my-4"
          style="margin-bottom:5px !important;padding:0 25px;font-size:13px;color:#0066B1;"
        >
          ({{ $t("m.confirmOrder.tipsModel2") }})
        </p>
      </b-modal>

      <!-- <b-modal ref="notice" class="notice" ok-only :ok-title="$t('m.home.ok')" >
        <p
          class="my-3"
          style="text-align:left;margin-bottom:5px !important;padding:0 25px;font-size:15px;white-space:pre-wrap"
        >{{$t('m.home.sdNotice')}}</p>
        <p style="font-size:0.9rem;font-weight:bold;margin-top:1rem">
          {{$t('m.home.noticeFooter')}}
          <a
            style="color:#0066B1;font-size:0.9rem;margin-top:1rem;font-weight:light;background-color: white!important"
            href="tel:400-115-0606"
          >400-115-0606</a>
        </p>
      </b-modal> -->
    </footer>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import {
  dateAdd,
  formatDateAppoint,
  formatDate,
  daysBetween,
  str2Time,
  getIntervalHour,
} from "@/utils/DateFomatUtil";
import { commonlyPricingList, pricingList } from "../api/parking.js";
import { placeAnOrder, placeDisperserOrder } from "../api/order.js";
import { placeCanOrder } from "../api/order.js";
import { userInfo } from "../api/user.js";
import { reject } from "q";

export default {
  name: "ConfirmOrder",
  data() {
    return {
      chargeType: 3, // 默认选择交流车位
      picker: {
        data: [["专属停车充电服务", "专属停车充电服务-直流充电"]],
        anchor: [],
      },
      // selectedCard:'',
      cardType: [],
      radioTitle: false,
      radio1Flag: false,
      radio2Flag: false,
      placeEmpty: true,
      getChargeType: "",
      hasDisperser: 0,
      pickerSelect: "",
      inMinute: "45",
      pickerVisible: "",
      provinceName: "京",
      lencesNumber: "",
      appointHour: 1,
      money: 0,
      yearFormat: "{value} 年",
      appointInTimeStart: undefined, // 允许预约入场时间起始
      appointInTimeEnd: undefined, // 允许预约入场时间结束
      appointOutTimeStart: undefined, // 允许预约离场时间起始
      appointOutTimeEnd: undefined, // 允许预约离场时间结束
      datePickerSelectAppointInTime: undefined, // 预约入场时间
      datePickerSelectAppointInTimeStr: "", //预约入场时间展示
      datePickerSelectAppointOutTime: undefined, //预约离场时间
      datePickerSelectAppointOutTimeStr: "", //预约离场时间展示
      isCarIdRequired: true,
      parkingId: "",
      itemTimeList: [],
      latitude: "", //坐标
      longitude: "", //坐标
      orderId: "", //订单Id
      message: "", //提示信息
      defaultChecked: false, //同意
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      lastTimeSelectIndex: -1,
      carType: null,
      disabledBtn: true,
      isVip: false,
      discount: 0.0,
      selectPrice: 0, //常用小时原价格
      selectDiscount: 0, //折扣
      allPricingList: [],
      selfService: undefined,
    };
  },
  mounted() {
    // if(this.$route.params.id==="61"){
    //  this.$refs.notice.show();
    // }
    if (sessionStorage.getItem("c")) {
      this.provinceName = "粤";
    }
    let thiss = this.$refs.picker;
    this.pickerSelect = this.picker.data[0][0];
    thiss.setSlotsByValues = function(values) {
      const setSlotValue = thiss.$refs.picker.setSlotValue;
      if (thiss.type === "time") {
        setSlotValue(0, values[0]);
        setSlotValue(1, values[1]);
      }
      if (thiss.type !== "time") {
        setSlotValue(0, values[0]);
        setSlotValue(1, values[1]);
        setSlotValue(2, values[2]);
        if (thiss.type === "datetime") {
          setSlotValue(3, values[3]);
          setSlotValue(4, values[4]);
        }
      }
      let minuteValues = thiss.$refs.picker.$children[4].values;
      for (let i = 0; i < minuteValues.length; i++) {
        if (parseInt(minuteValues[i]) % 15 !== 0) {
          minuteValues.splice(i, 1);
          i--;
        }
      }
      [].forEach.call(thiss.$refs.picker.$children, (child) => {
        child.doOnValueChange();
      });
    };
  },
  methods: {
    handlePickerConfirm(v) {
      this.pickerSelect = v[0].value;
    },
    handlePickerCancel() {},
    show() {
      this.$refs.chargePicker.show();
    },
    openPicker(type) {
      if (type === 2) {
        let dataminute = new Date(
          this.datePickerSelectAppointInTime
        ).getMinutes();
        dataminute = dataminute < 10 ? "0" + dataminute : dataminute;
        this.$refs.picker2.$refs.picker.$children[4].$el.innerHTML =
          '<div class="picker-slot-wrapper" style="height: 252px; transform: translate(0px, 108px) translateZ(0px);"><div class="picker-item picker-selected" style="height: 36px; line-height: 36px;">' +
          dataminute +
          "</div>";
        this.$refs.picker2.open();
        // this.initAppointInTime();
      } else {
        this.$refs.picker.open();
        // this.initAppointIntTime();
      }
    },
    handleConfirm: function(type) {
      if (type === 2) {
        this.$refs.picker2.close();
      } else {
        this.$refs.picker.close();
      }
    },
    validLicense: function() {
      this.lencesNumber = this.lencesNumber.toUpperCase();
    },
    // 入场时间时间范围
    initAppointInTime() {
      //预约入场时间
      let nowDateTemp = new Date();
      let nowMimiuteTemp = nowDateTemp.getMinutes();
      let addMiniuteTemp =
        Math.ceil(nowMimiuteTemp / 15) * 15 + 15 - nowMimiuteTemp;
      // 允许预约入场起始时间
      this.appointInTimeStart = dateAdd("mm", addMiniuteTemp, nowDateTemp);
      // 允许预约入场截止时间
      this.appointInTimeEnd = dateAdd("hh", 4, this.appointInTimeStart);
      this.datePickerSelectAppointInTime = new Date(this.appointInTimeStart);
    },
    //离场时间范围
    initAppointOutTime() {
      let minHour = this.parkingId == 64 ? 2 : 1;
      // 允许预约离场开始时间
      this.appointOutTimeStart = dateAdd(
        "hh",
        minHour,
        this.datePickerSelectAppointInTime
      );
      // 允许预约离场截止时间
      this.appointOutTimeEnd = dateAdd(
        "hh",
        this.allPricingList.length || 72,
        this.datePickerSelectAppointInTime
      );

      this.datePickerSelectAppointOutTime = dateAdd(
        "hh",
        this.appointHour || minHour,
        this.datePickerSelectAppointInTime
      );
    },
    //判断同意赋值
    onDefaultChecked: function() {
      this.defaultChecked = !this.defaultChecked;
    },
    //判断是否为空
    checkNull: function() {
      if (!this.isCarIdRequired) {
        if (this.lencesNumber.length > 7 || this.lencesNumber.length < 6) {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = this.$t("m.confirmOrder.errorcarNo");
          this.tipType = "error";
          return false;
        }
      }
    },
    matchLicensplate(carName) {
      var patt = /^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新使领][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{4}([\dABCDEFGHJKLNMxPQRSTUVWXYZ]|[\u4e00-\u9fa5]|[\dABCDEFGHJKLNMxPQRSTUVWXYZ][\u4e00-\u9fa5]|[\dABCDEFGHJKLNMxPQRSTUVWXYZ]{2})$/;
      if (!patt.test(carName)) {
        return false;
      }
      return true;
    },
    //提交订单按钮
    sumitOrder: function() {
      if (!this.disabledBtn) {
        return;
      }
      this.disabledBtn = false;

      if (this.checkNull() === false) {
        this.disabledBtn = true;
        return;
      }
      let isTemporary = null; //是否临牌
      if (!this.isCarIdRequired) {
        isTemporary = 2;
      } else if (this.isCarIdRequired) {
        isTemporary = 1;
      }
      let carName = this.provinceName + this.lencesNumber.toUpperCase(); //车牌号
      if (!this.matchLicensplate(carName)) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t("m.confirmOrder.errorcarNo");
        this.tipType = "error";
        return false;
      }
      let dateTimesa = this.datePickerSelectAppointInTimeStr + ":00";
      if (dateTimesa < formatDate("yyyy-MM-dd hh:mm")) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t("m.confirmOrder.errorMassage");
        this.tipType = "error";
        return;
      }
      let subData = {
        isTemporary: isTemporary,
        licenseplate: carName,
        appointInTime: dateTimesa,
        appointTime: this.appointHour,
        parkingId: this.parkingId,
        longitude: this.longitude,
        latitude: this.latitude,
        chargeType: this.chargeType,
        disperser: this.hasDisperser == 1 ? true : false,
        source: 1,
        // cardType: this.selectedCard
      };
      placeAnOrder(subData).then(
        (response) => {
          if (response.data.status !== 200) {
            this.disabledBtn = true;
            this.message = response.data.message;
            this.tipShow = "1" + Math.random() * 1000;
            this.tipType = "warning";
            return false;
          }
          this.orderId = response.data.result.orderId;
          if (this.orderId === -1) {
            this.$refs["disperserSelect"].show();
            return;
          }
          this.$router.push("/submitOrder/" + this.orderId);
        },
        (err) => {
          reject(err);
        }
      );
    },
    disperserOrder() {
      if (this.checkNull() === false) {
        this.disabledBtn = true;
        return;
      }
      let isTemporary = null; //是否临牌
      if (!this.isCarIdRequired) {
        isTemporary = 2;
      } else if (this.isCarIdRequired) {
        isTemporary = 1;
      }
      let carName = this.provinceName + this.lencesNumber.toUpperCase(); //车牌号
      if (!this.matchLicensplate(carName)) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t("m.confirmOrder.errorcarNo");
        this.tipType = "error";
        return false;
      }
      let dateTimesa = this.datePickerSelectAppointInTimeStr + ":00";
      if (dateTimesa < formatDate("yyyy-MM-dd hh:mm")) {
        this.tipShow = "1" + Math.random() * 1000;
        this.message = this.$t("m.confirmOrder.errorMassage");
        this.tipType = "error";
        return;
      }
      let subData = {
        isTemporary: isTemporary,
        licenseplate: carName,
        appointInTime: dateTimesa,
        appointTime: this.appointHour,
        parkingId: this.parkingId,
        longitude: this.longitude,
        latitude: this.latitude,
        source: 1,
      };
      placeDisperserOrder(subData).then((response) => {
        if (response.data.status !== 200) {
          this.disabledBtn = true;
          this.message = response.data.message;
          this.tipShow = "1" + Math.random() * 1000;
          this.tipType = "warning";
          return false;
        }
        this.orderId = response.data.result.orderId;
        this.$router.push("/submitOrder/" + this.orderId);
      });
    },
    ProvinceList: function() {
      if (this.selfService == 1) {
        return;
      }
      this.$router.push("/ProvinceList");
    },
    carDate: function() {
      this.$router.push("/parkingDuration/" + this.parkingId);
    },
    changeProvince: function(val) {
      this.provinceName = val;
      localStorage.setItem("provinceName", val);
    },
    //获取用户车牌数据信息
    loadUserInfo: function() {
      userInfo().then((response) => {
        if (response.data.status === 200) {
          this.carType = response.data.licenseplate;
          if (response.data.result.licenseplate === "临") {
            this.isCarIdRequired = true;
          } else {
            let parkName = response.data.result.licenseplate;
            if (!parkName) {
              if (sessionStorage.getItem("c")) {
                this.provinceName = "粤";
              } else {
                this.provinceName = "京";
              }
            } else {
              this.provinceName = parkName.substr(0, 1);
              this.lencesNumber = parkName.substr(1, 8);
            }
            localStorage.setItem("provinceName", this.provinceName);
          }
        } else {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = response.data.message;
          this.tipType = "warning";
        }
        this.isVip = response.data.result.vipCardId != null;
        this.discount = response.data.result.discount;
        this.cardType = response.data.result.vipCards;
        localStorage.setItem("isVip", this.isVip);
        localStorage.setItem("discount", this.discount);

        this.loadTotalPricingList();
      });
    }, //加载全部停车时长
    loadTotalPricingList: function() {
      pricingList({ parkingId: this.parkingId }).then((response) => {
        if (response.data.status === 200) {
          this.allPricingList = [];
          response.data.result.forEach((e) => {
            e.list.forEach((o) => {
              if (this.isVip) {
                o.discount = (o.discount * this.discount).toFixed(2);
                o.discountPrice = (o.discountPrice * this.discount).toFixed(2);
              }
              this.allPricingList.push(o);
            });
          });
          this.initAppointInTime();
        } else {
          this.tipShow = "1" + Math.random() * 1000;
          this.message = response.data.message;
          this.tipType = "warning";
        }
      });
    },
    //获取全部的时间，得到相应的数据
    getDataOrder(hour) {
      if (hour) {
        this.money = 0;
        this.allPricingList.forEach((e) => {
          if (hour === e.hour) {
            this.appointHour = e.hour;
            this.money = e.discountPrice;
            this.selectPrice = e.price;
            this.selectDiscount = e.discount;
            return;
          }
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== "ProvinceList" && from.name !== "parkingDuration") {
      to.meta.otherBack = true;
    }
    next();
  },
  //页面缓存后每次都会调用
  activated() {
    this.chargeType = 0;
    this.radio1Flag = false;
    this.radio2Flag = false;
    this.radioTitle = false;
    this.$refs.picker2.close();
    this.$refs.picker.close();
    this.parkingId = this.$route.params.id;
    this.selfService = sessionStorage.getItem(
      "pakring-self-service" + this.parkingId
    );
    this.longitude = this.$route.params.longitude;
    this.latitude = this.$route.params.latitude;
    this.placeEmpty = this.$route.params.placeEmpty;
    this.getChargeType = this.$route.params.chargeType;
    this.hasDisperser = this.$route.params.hasDisperser;
    // this.allPricingList= []

    if (
      this.getChargeType.indexOf("2") != -1 &&
      this.getChargeType.indexOf("3") != -1
    ) {
      this.radio1Flag = true;
      this.radio2Flag = true;
      this.radioTitle = true;
      // this.chargeType=3
    } else if (this.getChargeType.indexOf("3") != -1) {
      this.radioTitle = true;
      this.radio1Flag = true;
      // this.chargeType=3
    } else if (this.getChargeType.indexOf("2") != -1) {
      this.radioTitle = true;
      this.radio2Flag = true;
      // this.chargeType=2
    }

    if (this.placeEmpty === "false") {
      // this.chargeType=3
    }
    this.disabledBtn = true;
    this.isCarIdRequired = false;
    this.defaultChecked = false;

    eventBus.$on("provinceName", this.changeProvince);
    eventBus.$on("hour", this.getDataOrder);
    if (this.$route.meta.otherBack) {
      this.$route.meta.otherBack = false;

      this.getDataOrder(this.appointHour);
      this.loadUserInfo();
    }
  },
  created() {
    this.loadUserInfo();
  },
  watch: {
    datePickerSelectAppointInTime: function(val) {
      this.datePickerSelectAppointInTimeStr = formatDateAppoint(
        "yyyy-MM-dd hh:mm",
        new Date(val)
      );
      this.initAppointOutTime();
    },
    datePickerSelectAppointOutTime: {
      handler(val, oldVal) {
        this.datePickerSelectAppointOutTimeStr = formatDateAppoint(
          "yyyy-MM-dd hh:mm",
          new Date(val)
        );
        let appointeInTime = new Date(this.datePickerSelectAppointInTime);
        let appointeOutTime = new Date(val);
        appointeInTime.setSeconds(0);
        appointeInTime.setMilliseconds(0);
        appointeOutTime.setSeconds(0);
        appointeOutTime.setMilliseconds(0);
        let appintHours = getIntervalHour(appointeInTime, appointeOutTime);
        this.getDataOrder(appintHours);
      },
      deep: true,
    },
    appointHour: function(val) {
      let result = dateAdd("hh", val, this.datePickerSelectAppointInTime);
      this.datePickerSelectAppointOutTimeStr = formatDateAppoint(
        "yyyy-MM-dd hh:mm",
        result
      );
    },
  },
};
</script>

<style>
/* 开关 */
/* Checkbox Radio */
.checkbox-component {
  display: inline-block;
}

.checkbox-component > input + label > .input-box,
.radio-component > input + label > .input-box {
  position: relative !important;
  border: 1px solid #939393 !important;
  border-radius: 1em !important;
  width: 2.1em !important;
  height: 1.2em !important;
  background: #fff !important;
  transition: background 0.2s ease-in !important;
  vertical-align: -17% !important;
}

.checkbox-component > input + label > .input-box > .input-box-tick,
.radio-component > input + label > .input-box > .input-box-circle {
  display: none;
}

.checkbox-component > input + label > .input-box:before,
.radio-component > input + label > .input-box:before {
  content: "" !important;
  position: absolute !important;
  top: -1px !important;
  left: -1px !important;
  text-align: left !important;
  border: 1px solid #939393 !important;
  border-radius: 70% !important;
  width: 1.4em !important;
  height: 1.2em !important;
  background: #fff !important;
  transition: transform 0.3s ease-out !important;
}

.checkbox-component > input:checked + label > .input-box,
.radio-component > input:checked + label > .input-box {
  background: #63b65d !important;
}

.checkbox-component > input:checked + label > .input-box:before,
.radio-component > input:checked + label > .input-box:before {
  border-color: #498d47 !important;
  transform: translateX(0.6em) !important;
}

/* 开关结束 */
section .dateTime .media-container {
  position: relative;
}

section .dateTime .modal-dialog {
  height: 100% !important;
}

section .dateTime #modalsm___BV_modal_header_ {
  padding-bottom: 5px;
}

section .dateTime .modal-dialog {
  margin: 0 auto;
}

section .dateTime .modal-dialog .modal-content {
  top: 34% !important;
}

.contextInfo .mint-popup .picker .picker-items .picker-slot:nth-child(1) {
  /*display: none !important;*/
  flex: 0.2 20% !important;
}

/*.contextInfo .mint-popup .picker .picker-items .picker-slot:nth-child(2) {
  !* display: none !important; *!
  flex: 0.3 5% !important;
  margin-left: 20px;
}

.contextInfo
.mint-popup
.picker
.picker-items
.picker-slot:nth-child(2)
.picker-slot-wrapper
.picker-item {
  padding-right: 0;
}

.contextInfo .mint-popup .picker .picker-toolbar {
  margin: 0 5%;
}

.contextInfo .mint-popup .picker .picker-toolbar .mint-datetime-cancel {
  text-align: left;
}

.contextInfo .mint-popup .picker .picker-toolbar .mint-datetime-confirm {
  text-align: right;
}

.contextInfo .mint-popup .picker .picker-items .picker-slot:nth-child(3) {
  !* display: none !important; *!
  flex: 0.3 4% !important;
  margin-right: 2px;
}

.contextInfo
.mint-popup
.picker
.picker-items
.picker-slot:nth-child(3)
.picker-slot-wrapper {
  text-align: left;
}

.contextInfo .mint-popup .picker .picker-items .picker-slot:nth-child(4) {
  flex: 0.3 3% !important;
}

.contextInfo
.mint-popup
.picker
.picker-items
.picker-slot:nth-child(4)
.picker-slot-wrapper {
  !* margin-right: 32px; *!
  text-align: right;
}

.contextInfo
.mint-popup
.picker
.picker-items
.picker-slot:nth-child(3)
.picker-slot-wrapper
.picker-item {
  padding-left: 0;
}*/

.contextInfo
  .mt-datetime-two
  .picker
  .picker-items
  .picker-slot:nth-child(5)
  .picker-slot-wrapper
  .picker-item {
  /*display: none;*/
  /*visibility:hidden;*/
  /*display: -webkit-box !important;*/
  /*-webkit-transition-duration: 0s;*/
  /*transition-duration: 0s;*/
  /*display: flex !important;;*/
  /*line-height: 0;*/
  /*height: 0;*/
  /*width: 0;*/
  /*overflow: hidden;*/
  /*opacity:0;*/
  /*clip-path: none;*/

  /*-webkit-backface-visibility: hidden;*/
  /*backface-visibility: hidden;*/

  /*position: absolute;*/
}

.contextInfo
  .mt-datetime-two
  .picker
  .picker-items
  .picker-slot:nth-child(5)
  .picker-slot-wrapper
  .picker-item:nth-child(1) {
  /*display:block !important;*/
  /*visibility:visible !important;*/
  /*width: 100%;*/
  /*height: 36px;*/
  /*opacity:1;*/
  /*line-height: 36px;*/
}
</style>
<style scoped>
.charge-type {
  text-align: left;
}

header,
section p {
  margin: 0 auto;
  padding: 0;
}

section {
  margin-bottom: 60px;
}

section .userProtocol {
  text-align: left;
  padding-top: 5px;
  font-size: 14px;
}

section .userProtocol .custom-control {
  padding-top: 6px;
  margin-right: 0px;
}

section .userProtocol .tongyi {
  display: inline-block;
}

section .carTypeNo .carIds {
  display: inline-block;
  text-align: left;
  float: left;
}

section .carTypeNo .linpai {
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  float: right;
}

section .context {
  border-bottom: 1px solid #efefef;
  line-height: 35px;
  font-size: 13px;
}

section .contextInfo {
  width: 100%;
  height: 45px;
  padding: 10px 0;
  border-bottom: 1px solid #efefef;
}

section .dateType {
  display: inline-block;
  float: left;
}

section .dateTypes {
  display: inline-block;
  float: right;
}

section .contextInfos {
  width: 100%;
  height: 20px;
  padding: 10px 0;
}

section .province {
  margin-top: 10px;
  border-top: 1.3px solid #efefef;
  border-bottom: 1.3px solid #efefef;
  line-height: 45px;
}

section .cost .carDate {
  display: inline-block;
  padding-right: 15%;
}

section .cost .carDates {
  display: inline-block;
  padding-left: 15%;
}

#date {
  margin-top: 5px;
  padding-bottom: 10px;
  border-bottom: 1.3px solid #efefef;
}

#date p {
  text-align: left;
  font-size: 14px;
}

#date p span {
  vertical-align: middle;
}

#date p span img {
  padding-bottom: 3px;
}

#date .bv-example-row {
  margin-bottom: 5px;
}

.cost {
  padding: 18px 0;
  border-bottom: 1.3px solid #efefef;
}

.cost div {
  text-align: center;
}

.cost div p {
  font-size: 14px;
}

.cost div h5 {
  color: #0066b1;
}

.row .col {
  border: 1px solid #838383;
}

.row .col {
  padding: 0 3px;

  border-radius: 4px;
  margin-right: 7px;
  padding-bottom: 5px;
}

.row .em-line {
  display: block;
  width: 100%;
  height: 16px;
}

.row .col em {
  display: table;
  font-size: 10px;
  color: #fff;
  float: right;
  position: relative;
  background-color: #0066b1;
  min-width: 35px;
  line-height: 16px;
  padding-right: 4px;
}

.row .col em:before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-right: 8px solid #0066b1;
  position: absolute;
  top: 0;
  left: -16px;
}

.row .col:last-child {
  margin-right: 0px;
}

.row .col p {
  font-family: "宋体";
  font-size: 9px !important;
}

.row .col strong {
  font-size: 17px;
}

.row .col p span {
  vertical-align: middle;
  text-decoration: line-through;
  font-size: 7px !important;
}

.active {
  padding-bottom: 0px !important;
  background-color: #0066b1;
  color: #fff !important;
}

footer p {
  margin: 0 auto;
  padding: 0;
  font-size: 13px;
  color: #666;
}

footer a {
  width: 81%;
  color: #fff;
  background-color: #0066b1;
  line-height: 30px;
  font-size: 18px;
}

footer .notice .modal-content {
  margin: 0 auto;
  margin-top: 200px;
  width: 95%;
}

footer .notice .modal-header {
  padding: 0rem;
}
</style>
